import Service from '@/services/Service'

class BillsService extends Service {
  constructor() {
    super('BILLS')
    this.resource = 'bills'
  }

  translateToFirebird(obj) {
    return obj
  }

  translateFromFirebird(obj) {
    return obj
  }

  createRequestUrl(query) {
    let requestUrl = `${this.resource}?`

    if(query)
      query = this.encodeQueryValues(query);

    if (query.todos != null)
      requestUrl += this.hasParameter(requestUrl)
        ? `&TODOS=${query.todos}`
        : `TODOS=${query.todos}`
    if (query.page)
      requestUrl += this.hasParameter(requestUrl)
        ? `&page=${query.page}`
        : `page=${query.page}`
    if (query.empresa)
      requestUrl += this.hasParameter(requestUrl)
        ? `&EMPRESA=${query.empresa}`
        : `EMPRESA=${query.empresa}`
    if (query.documento)
      requestUrl += this.hasParameter(requestUrl)
        ? `&DOCUMENTO=${query.documento}`
        : `DOCUMENTO=${query.documento}`
    if (query.vendedor)
      requestUrl += this.hasParameter(requestUrl)
        ? `&VENDEDOR=${query.vendedor}`
        : `VENDEDOR=${query.vendedor}`
    if (query.dataIni)
      requestUrl += this.hasParameter(requestUrl)
        ? `&DATAINI=${query.dataIni}`
        : `DATAINI=${query.dataIni}`
    if (query.dataFim)
      requestUrl += this.hasParameter(requestUrl)
        ? `&DATAFIM=${query.dataFim}`
        : `DATAFIM=${query.dataFim}`
    return requestUrl
  }

  async getBills(query = null) {
    let requestUrl = this.createRequestUrl(query)
    return await this.getAPI(requestUrl)
  }

  async getPendingBillsResumePDV(idCompany) {
    let requestUrl = `${this.resource}/pending-pdv/${encodeURIComponent(idCompany)}`
    return await this.getAPI(requestUrl)
  }

  async getBill(id) {
    const requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    const data = await this.getAPI(requestUrl)
    return this.translateFromFirebird(data)
  }
}

export default new BillsService()
